import React from "react";
import {
  View,
  StyleSheet,
  ImageStyle,
  StyleProp,
  ViewStyle,
  useWindowDimensions,
  Text,
} from "react-native";
import {
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import { SCREEN_WIDTH } from "app/utils/common";
import RoundImageWithIcon from "./RoundImageWithIcon";
import { Crop } from "../models/diagnosis";
import { useTranslation } from "react-i18next";

interface Props {
  cropList: Crop[];
  mainContainerstyle?: StyleProp<ViewStyle>;
  activeImageContainerStyle?: Object;
  imageStyle?: ImageStyle;
  isIconvisible?: boolean;
  icon?: JSX.Element;
  iconContainerStyle?: Object;
  handleImageClick?: (arg: Crop) => void;
  handleIconClick?: (srg: Crop) => void;
  selectedCropId?: number | null;
}
export const calculateDynamicMargin = (
  widthOfItem: number,
  maxNoOfItemsInRow: number,
  padding = 0,
  splitMarginInto?: number
) => {
  return (
    (SCREEN_WIDTH - widthOfItem * maxNoOfItemsInRow - padding) /
    (splitMarginInto || maxNoOfItemsInRow * 2)
  );
};

const CropsList = ({
  cropList,
  mainContainerstyle,
  activeImageContainerStyle,
  imageStyle,
  icon,
  iconContainerStyle,
  handleImageClick,
  selectedCropId,
}: Props) => {
  const { width } = useWindowDimensions();
  const itemWidth = width >= 768 ? "20%" : "33.33%";
  const { t } = useTranslation();
  return (
    <View
      style={[
        COMMON_STYLES["p0.5"],
        styles.container,
        COMMON_STYLES.br1,
        COMMON_STYLES.b1,
        BORDER_STYLES.borderNeutral20,
      ]}
    >
      <Text
        style={[
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.EMPHASIZED,
          COMMON_STYLES["mb3/2"],
        ]}
      >
        {t("select_crop")}
      </Text>
      <View
        style={[
          mainContainerstyle,
          COMMON_STYLES.row,
          COMMON_STYLES.flex1,
          { flexWrap: "wrap", justifyContent: "flex-start" },
        ]}
      >
        {cropList.map((crop, index) => (
          <RoundImageWithIcon
            crop={crop}
            key={index}
            containerStyle={{
              width: itemWidth,
            }}
            activeImagecontainerStyle={activeImageContainerStyle}
            imageStyle={imageStyle}
            isIcon={selectedCropId === crop.crop_id}
            icon={icon}
            onClick={handleImageClick}
            iconContainerStyle={iconContainerStyle}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#F2F2F2",
  },
});

export default CropsList;
